/**
 * Created by Pradeep Kumar on 5/20/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {IReelStartSpinData, IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {TombOfNefertitiParsedGameData} from "../../server/data/TombOfNefertitiParsedGameData";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {TombOfNefertitiGameMode} from "../../gamemode/TombOfNefertitiGameMode";
import {TombOfNefertitiReels} from "../reelarea/TombOfNefertitiReels";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";

export interface IReelStartSpinDataTON extends IReelStartSpinData {
    spinSpeed: number;
}

export class TombOfNefertitiReelController extends SpinReelController {

    public static ADD_SPIN_START_DELAY:string = "TombOfNefertitiReelController_addSpinStartDelay";

    private _curseFeatureStopDelays: number[] = [8, 0, 0, -2.5, 0, 0, 0, 0, 0, 0, 0, 0, 2.5, 0, 0];
    private _curseFeatureFastStopDelays: number[] = [4, 0, 0, -2, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0];

    private _mask: PIXI.Sprite | PIXI.Graphics;
    private _isInit: boolean = false;
    private _extraSpinStartDelay:number = 0;
    private _isCurseFeatureTriggered: boolean = false;
    private _isWildRaidFeatureTriggered: boolean = false;
    private _fastSpinStatusOnSpinStart: boolean = false;
    private _scatterPositions: number[] | undefined = [];
    private _curseReSpinSpeed: number = 0.3; // this variable is used for curse reSpin sync speed.

    get stopReelSet(): string[] {
        return this._stopReelSet;
    }

    protected parseInitData(data: ParsedInitData):void {
        super.parseInitData(data);
        this._nextFullReelSet = Helper.getReelSet(data.nextReelSetName, this._reelId);
    }

    public onGameDataParsed(data:TombOfNefertitiParsedGameData):void {
        super.onGameDataParsed(data);
        this._isCurseFeatureTriggered = data.isCurseFeatureTriggered || data.isCurseFeatureReSpinTriggered || (data.nextReelSetName === "CURSE_REELSET");
        this._isWildRaidFeatureTriggered = data.isWildRaidFeatureTriggered;
        this._scatterPositions = data.scatterPositions ? data.scatterPositions.concat() : [];
        this._nextFullReelSet = Helper.getReelSet(this._isCurseFeatureTriggered ? "CURSE_REELSET" : data.nextReelSetName, this._reelId);
        // need to type cast it as this reduce will not work directly on boolean.
        this._nearWinReels = this._nearWinReels ? this._nearWinReels.reduce((acc, currEl) => acc.concat(<any>currEl), []) : [];
    }

    protected addEventListeners(): void {
        super.addEventListeners();
        EventHandler.addEventListener(this, TombOfNefertitiReelController.ADD_SPIN_START_DELAY, (event:GameEvent) => this.addSpinStartDelay(event.params[0], event.params[1]));

        // #370, removing this as it is not required in this game.
        EventHandler.removeEventListener(this, ReelEvent.REEL_ADD_STOP_DELAY);
    }

    private addSpinStartDelay(reelId:number, delay:number):void {
        if(this.reelId != reelId) {
            return;
        }
        this._extraSpinStartDelay = delay;
    }

    protected startSpinAnimation(data:IReelStartSpinData, previousDelay:number):number {
        previousDelay += this._extraSpinStartDelay;
        this._extraSpinStartDelay = 0;
        return super.startSpinAnimation(data, previousDelay);
    }

    /**
     * @inheritDoc
     * @override It is overridden to update mask for init start spin step if the symbol is not an overlapping symbol and the reel is active.
     * @param data
     * @param previousDelay
     */
    public startSpin(data: IReelStartSpinDataTON, previousDelay:number): number {
        this._fastSpinStatusOnSpinStart = data.fastSpin;

        if (this._isInit && data.active && TombOfNefertitiGameConfig.instance.OVERLAPPING_SYMBOLS.indexOf(this._stopReelSet[0]) === -1) {
            const offset = 0;

            this._mask.height = TombOfNefertitiGameConfig.instance.SYMBOL_HEIGHT;
            this._mask.y = offset;

            //What is this supposed to do? If it's null we can't set visible on it!
            /*if (this.allSymbols[0] == null) {
                this.allSymbols[0].visible = true;
            }*/

            this._isInit = false;
        }

        if (data.active && TombOfNefertitiGameConfig.instance.OVERLAPPING_SYMBOLS.indexOf(this._stopReelSet[0]) !== -1) {
            const offset = -(TombOfNefertitiGameConfig.instance.SYMBOL_HEIGHT * 0.5);

            this._mask.height = TombOfNefertitiGameConfig.instance.SYMBOL_HEIGHT * 1.5;
            this._mask.y = offset;
        }

        if(!data.spinSpeed){
            data.spinSpeed = TombOfNefertitiGameConfig.instance.REEL_SPIN_SPIN_SPEED;
        }

        // Use nextGameMode here because the current mode is set by the nextGameMode in super.startSpin.
        // to set the spin speed which will be used in "setStartSpinData" method(after the slot game is updated to ^0.39.19)
        this._curseReSpinSpeed = (this._nextGameMode.indexOf(TombOfNefertitiGameMode.RESPIN) === -1) ? data.spinSpeed
            : ((this._isCurseFeatureTriggered && this.reelId > 2 && this.reelId < 12) ? 0.3 : data.spinSpeed);

        return super.startSpin(data, previousDelay);
    }

    // to set the spin speed which is overridden(by the super call) for curse reSpin sync speed
    protected setStartSpinData(data: IReelStartSpinData): void {
        super.setStartSpinData(data);

        this._spinReelPartAnimator.spinSpeed = this._curseReSpinSpeed;
    }

    public setSyncReelSpeed(reelId: number, endSpeed: number, steps: number): number {
        this._spinReelPartAnimator.setupTweenSpinSpeedQueue(endSpeed, this._spinReelPartAnimator.isQuickStop ? 2 : steps);

        return this._spinReelPartAnimator.spinSpeedsQueue.reduce((a, b) => a + b, 0);
    }

    public isQuickStop(): boolean {
        return this._spinReelPartAnimator.isQuickStop || false;
    }

    protected onInitDataParsed(data: ParsedInitData): void {
        this._isInit = true;
        this._isCurseFeatureTriggered = (data.nextReelSetName === "CURSE_REELSET");

        super.onInitDataParsed(data);
    }

    // to hide the first symbol on init.
    protected initReelStrip(): void {
        super.initReelStrip();

        if (this._reelInitialized) {
            this.allSymbols[0]!.visible = false;
        }
    }

    protected onSpinStartedCompleted(): void {
        const offset = 0;

        this._mask.height = TombOfNefertitiGameConfig.instance.SYMBOL_HEIGHT;
        this._mask.y = offset;

        super.onSpinStartedCompleted();
    }

    /**
     * @description To create the reel view for each individual reel.
     *
     */
    protected createReelView(): PIXI.Container {
        const reelView: PIXI.Sprite = new PIXI.Sprite(),
            maskShape: PIXI.Graphics = new PIXI.Graphics(),
            offset = TombOfNefertitiGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfNefertitiGameConfig.instance.SYMBOL_HEIGHT;

        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(-TombOfNefertitiGameConfig.instance.SYMBOL_WIDTH / 2, 0, TombOfNefertitiGameConfig.instance.SYMBOL_WIDTH, TombOfNefertitiGameConfig.instance.SYMBOL_HEIGHT);
        maskShape.endFill();

        if (this._mask != null) {
            reelView.removeChild(this._mask);
        }

        maskShape.y -= offset;
        maskShape.height += offset;

        this._mask = maskShape;

        reelView.addChild(this._mask);
        reelView.mask = this._mask;
        return reelView;
    }

    protected setCurrentReelSet(data: { reelSetName: string; reelSetPosition?: number, reelId?: number }): void {
        if (this.reelId !== data.reelId) {
            return;
        }
        super.setCurrentReelSet(data);
    }

    protected makeUpStopReelSet(bottomFillUpTotalNum: number, init: boolean): string[] {
        let retVal: string[] = super.makeUpStopReelSet(bottomFillUpTotalNum, init);
        if(!TombOfNefertitiGameConfig.instance.CURRENT_SPIN_HAS_CURSE) {
            retVal[retVal.length - 1] = "L3";

            TombOfNefertitiGameConfig.instance.CURSE_REEL_SET_LAST_THREE_SYMS = [];

            TombOfNefertitiGameConfig.instance.REEL_SPIN_STOP_ELASTIC_CONFIG = [1.5, 0.95];
            return retVal;
        }

        if (this.reelId > 2 && this.reelId < 12) {
            if (this.reelId === 3) {
                let length: number = retVal.length;
                TombOfNefertitiGameConfig.instance.CURSE_REEL_SET_LAST_THREE_SYMS = retVal.slice(length - 3, length);
            }

            retVal = retVal.concat(TombOfNefertitiGameConfig.instance.CURSE_REEL_SET_LAST_THREE_SYMS);
        }

        return retVal;
    }

    /**
     * @inheritDoc
     * @override to fix #370 -> applied solution is bad but after the upgrade in slot game, all the delay thing is messed up with this game at least.
     * @param stopData
     * @param previousStopTime
     */
    public stopSpin(stopData:IReelStopSpinData, previousStopTime:number):number {
        let retVal: number = super.stopSpin(stopData, previousStopTime);

        if (this._isCurseFeatureTriggered) {
            if (stopData.quickStop) {
                return 0.01;
            }

            if (this._fastSpinStatusOnSpinStart) {
                if (this._reelId > 2 && this._reelId < 12) {
                    retVal = 2;
                } else {
                    retVal = 4;
                }
            } else {
                if (this._reelId > 2 && this._reelId < 12) {
                    if (this._gameMode === TombOfNefertitiGameMode.RESPIN) {
                        retVal = 4;
                    } else {
                        retVal = 5.5;
                    }
                } else {
                    if (this._gameMode === TombOfNefertitiGameMode.RESPIN) {
                        retVal = 6;
                    } else {
                        retVal = 8;
                    }
                }
            }
        }

        return retVal;
    }

    // Overridden to fasten the reel spin; referred CreepyCarnivalTwo.
    protected getStopDelayDelta(stopSpinData: IReelStopSpinData): number {
        if (this._spinReelPartAnimator.isQuickStop) {
            return this.getQuickStopDelay(this.reelId);
        }

        if (!this._spinReelPartAnimator.isQuickStop && this._nearWinReels) {
            let extraTime: number = 0,
                stopDelay: number = 0;

            if (this._nearWinReels[this.reelId]) {
                stopDelay = TombOfNefertitiGameConfig.instance.REEL_NEAR_WIN_STOP_DELAY;
            }
            if (this._gameMode.indexOf("FREESPIN") !== -1) {
                if (this.reelId && Reels.getReel(this.reelId - 1)!.currentState != ReelAnimationState.INACTIVE && this._scatterPositions![this.reelId - 1]) {
                    extraTime += 0.5;
                }
            }
            else {
                if (TombOfNefertitiReels.thirdScatterId > -1 && this.reelId === (TombOfNefertitiReels.thirdScatterId + 1) && Reels.getReel(this.reelId - 1)!.currentState != ReelAnimationState.INACTIVE && this._scatterPositions![this.reelId - 1]) {
                    extraTime += 1;
                }
            }

            if(stopDelay) {
                return stopDelay + extraTime;
            }
        }

        if ((this._fastSpinStatusOnSpinStart || this._gameMode.indexOf("RESPIN") !== -1) && (!this._isCurseFeatureTriggered)) {
            return this.getFastSpinStopDelay(this.reelId) / 2;
        }

        return this.getNormalStopDelay(this.reelId);
    }

    protected getNormalStopDelay(reelId: number): number {
        if (this._isCurseFeatureTriggered) {
            return this.getCurseFeatureStopDelays(reelId);
        } else if (this._isWildRaidFeatureTriggered) {
            return this.getWildRaidFeatureStopDelays(reelId);
        } else {
            return super.getNormalStopDelay(reelId);
        }
    }

    protected getFastSpinStopDelay(reelId: number): number {
        if (this._isCurseFeatureTriggered) {
            return this.getCurseFeatureStopDelays(reelId);
        } else if (this._isWildRaidFeatureTriggered) {
            return this.getWildRaidFeatureStopDelays(reelId);
        } else {
            return super.getFastSpinStopDelay(reelId);
        }
    }

    private getCurseFeatureStopDelays(reelId: number): number {
        if (this._spinReelPartAnimator.isQuickStop) {
            return 0.001;
        }

        let delay: number;

        if (this._fastSpinStatusOnSpinStart || this._gameMode === TombOfNefertitiGameMode.RESPIN) {
            delay = this._curseFeatureFastStopDelays[reelId];

            if (this._gameMode === TombOfNefertitiGameMode.RESPIN && this._reelId === 0) {
                delay = 6;
            }
        } else {
            delay = this._curseFeatureStopDelays[reelId];
        }

        return delay;
    }

    private getWildRaidFeatureStopDelays(reelId: number): number {
        if (this._spinReelPartAnimator.isQuickStop) {
            return 0.01;
        }

        if (reelId === 0) {
            //reducing time delay for free spin
            if (this._gameMode.indexOf(GameMode.FREESPIN) !== -1) {
                if (this._fastSpinStatusOnSpinStart) {
                    return 2.5;
                } else {
                    return 3.5;
                }
            } else {
                if (this._fastSpinStatusOnSpinStart) {
                    return 5.5;
                } else {
                    return 8;
                }
            }
        } else {
            let stopDelayInReels = 0.25;
            if (!this._fastSpinStatusOnSpinStart) {
                stopDelayInReels = 0.1;
            }
            if (this._fastSpinStatusOnSpinStart) {
                stopDelayInReels /= 2;
            }
            return stopDelayInReels;
        }
    }
}